module.exports = __webpack_public_path__ + "img/clint12.26abb505.png";